import { sendRequestProtocols, sendRequestReport } from "../axios";
import { getReportUrl } from "@/components/api/localglobal";

export default {
  state: {
    registerBG: [],
    registerTotal: 0,
    swatches: [],
    rowsColor: []
  },
  mutations: {
    SET_REGISTER_BG(state, payload) {
      state.registerBG = payload;
    },
    SET_REGISTER_TOTAL(state, payload) {
      state.registerTotal = payload;
    },
    SET_SWATCHERS(state, payload) {
      const newSwatches = new Set(payload);
      state.swatches = Array.from(newSwatches);
    },
    SET_ROWS_COLOR(state, payload) {
      state.rowsColor = payload;
    }
  },
  actions: {
    SET_ROW_COLOR({ commit, state }) {
      commit(
        "SET_REGISTER_BG",
        state.registerBG.map(item => {
          const find = state.rowsColor.find(
            row => row.notificationNumber === item.notificationNumber
          );
          if (find === undefined) {
            item.color = "white";
          }

          if (find) {
            item.color = find.color;
          }

          return item;
        })
      );
    },
    async GET_REGISTER_BG({ commit, state, dispatch }, payload) {
      const { data } = await sendRequestProtocols(
        `registerBG`,
        "post",
        payload
      );
      if (!data.message) {
        commit("SET_REGISTER_BG", data.data);
        commit("SET_REGISTER_TOTAL", data.total);
      }

      dispatch("SET_ROW_COLOR");
    },
    async GET_FIRM_CONTACTS_UPDATE({ commit, getters }, payload) {
      const { data } = await sendRequestProtocols(`gosebase/${payload}`, "get");
      const rbg = getters.registerBG;
      rbg.map(item => {
        if (item.winner_inn === data.inn) {
          item.firm_info = { emails: data.emails, phones: data.phones };
        }
        return item;
      });
    },
    async GET_REGISTER_BG_FILE({ commit }, payload) {
      try {
        const { data } = await sendRequestReport(`registerbg`, "post", payload);
        const a = document.createElement("a");
        a.href = `${getReportUrl()}reports/${data.name}`;
        a.target = "_blank";
        a.click();
      } catch (e) {
        return e;
      }
    },
    async GET_REGISTER_BG_FILE_TO_ROBOT({ commit }, payload) {
      try {
        const { data } = await sendRequestReport(`registerbgrobot`, "post", payload);
        const a = document.createElement("a");
        a.href = `${getReportUrl()}reports/${data.name}`;
        a.target = "_blank";
        a.click();
      } catch (e) {
        return e;
      }
    },
    async PUT_ROW_COLOR({ commit, dispatch }, payload) {
      const { data } = await sendRequestProtocols(
        `registerBG/color`,
        "put",
        payload
      );
      commit("SET_ROWS_COLOR", data.list);
      commit(
        "SET_SWATCHERS",
        data.list.map(item => item.color)
      );
      dispatch("SET_ROW_COLOR");
    },
    async DELETE_ROW_COLOR({ commit, dispatch }, payload) {
      const { data } = await sendRequestProtocols(
        `registerBG/color`,
        "delete",
        payload
      );
      commit("SET_ROWS_COLOR", data.list);
      commit(
        "SET_SWATCHERS",
        data.list.map(item => item.color)
      );
      dispatch("SET_ROW_COLOR");
    },
    async GET_ROWS_COLOR({ commit, dispatch }, payload) {
      const { data } = await sendRequestProtocols(
        `registerBG/color/${payload}`,
        "get"
      );
      commit("SET_ROWS_COLOR", data);
      commit(
        "SET_SWATCHERS",
        data.map(item => item.color)
      );
      dispatch("SET_ROW_COLOR");
    }
  },
  getters: {
    registerBG: state => state.registerBG,
    registerBGTotal: state => state.registerTotal,
    swatches: state => state.swatches
  }
};
